export default "__VITE_ASSET__a8c621d7__"